module.exports = __webpack_public_path__ + "static/media/2014_aug_miles.8ce37234.jpg";